export default __webpack_public_path__ + "static/media/tela_edr.00ea7576.png";